<template>
  <v-dialog max-width="90%" v-model="open">
    <template v-slot:activator="{ props: activatorProps }">
      <v-col cols="6" lg="3">
        <v-card v-bind="activatorProps" @click="recordOpen()" height="320px">
          <v-container>
            <v-row>
              <v-col cols="12" align="center">
                <v-img :src="'https://ewr1.vultrobjects.com/crvd/cc/' + item.id + '/1.jpg'" height="180px">
                  <template v-slot:error>
                    <v-img class="mx-auto" height="180px" :src="require('@/assets/no-img.png')" />
                  </template>
                  <template v-slot:placeholder>
                    <v-skeleton-loader height="180px" type="image" />
                  </template>
                </v-img>


              </v-col>
            </v-row>
            <v-row>
              <v-col cols="9">{{ item.spacenumber }}</v-col>
              <v-col cols="3" align="right" v-if="item.premium == 1">
                <v-tooltip text="Premium Space">
                  <template v-slot:activator="{ props }">
                    <v-icon color="purple" v-bind="props">mdi-star</v-icon>
                  </template>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="9" class="text-body-1">{{ item.cemeteryname }}</v-col>
              <v-col cols="3" align="right" v-if="item.cemeteryid > -1">
                <v-tooltip text="Cemetery is Selling Space">
                  <template v-slot:activator="{ props }">
                    <v-icon color="yellow-darken-3" v-bind="props">mdi-star</v-icon>
                  </template>
                </v-tooltip>
              </v-col>
              <v-col cols="12" class="text-medium-emphasis">{{ item.city }}, {{ item.state }}</v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card>
        <v-container>
          <v-row>
            <v-col>
              <v-card-title>Space: {{ item.spacenumber }}</v-card-title>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" align="center">
              <v-img :src="'https://ewr1.vultrobjects.com/crvd/cc/' + item.id + '/1.jpg'" max-height="720px">
                <template v-slot:placeholder>
                  <v-skeleton-loader height="240px" type="image" />
                </template>
              </v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card-item v-if="item.cost && item.cost > 0">${{ item.cost.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</v-card-item>
              <v-card-item v-else>Contact for Price</v-card-item>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card-item><v-card-subtitle>Sold By: {{ item.sellername }}</v-card-subtitle></v-card-item>
            </v-col>
          </v-row>
        </v-container>

        <v-card-item>{{ item.description }}</v-card-item>

        <v-card-actions>
          <v-spacer/>
          <ContactDialog :item="item"/>
          <v-btn color="red" text="Flag" @click="isActive.value = false;"/>
          <v-btn color="red" text="Close" @click="isActive.value = false;"/>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import ContactDialog from './ContactDialog.vue';

export default {
  name: 'MarketItem',

  components: {
    ContactDialog
  },

  props:{
    item : Object
  },

  data: () => ({
    open : false,
  }),

  methods:{
    recordOpen(){
      fetch("https://app.cemeterycommunity.com:11000/api/addmarketplaceitemlog", { method: "POST", headers : { data : JSON.stringify( { type : 'Listing Viewed', itemid : this.item.id } ) } });
    }
  }
}
</script>